import { lineSubRows, type LineSubRow } from '../../../../utils/lineVatRows';
import type { StatementLine } from '../../../../utils/statementBlocks';
import { vatRateLabel } from '../../../../utils/vatRateLabel';
import { FigureCell } from './FigureCell';
import { STATEMENT_GRID } from './statementGrid';
import { UnsplitBadge } from './UnsplitBadge';

interface Props {
    line: StatementLine;
    currency: string;
}

const subRowName = (line: StatementLine, subRow: LineSubRow): string =>
    subRow.kind === 'rate'
        ? `${line.label} at ${vatRateLabel(subRow.figures.vatRatePercent)}`
        : `${line.label}, unsplit postings`;

function SubRowFigures({ subRow, currency }: { subRow: LineSubRow; currency: string }) {
    if (subRow.kind === 'unsplit') {
        return (
            <>
                <dd className="text-right">
                    <span className="sr-only">VAT rate, </span>
                    <UnsplitBadge />
                </dd>
                <FigureCell column="Gross" value={subRow.gross} currency={currency} />
                <FigureCell column="VAT" value={null} currency={currency} />
                <FigureCell column="Net" value={null} currency={currency} />
            </>
        );
    }
    return (
        <>
            <dd className="text-right">
                <span className="sr-only">VAT rate, </span>
                {vatRateLabel(subRow.figures.vatRatePercent)}
            </dd>
            <FigureCell column="Gross" value={subRow.figures.gross} currency={currency} />
            <FigureCell column="VAT" value={subRow.figures.vat} currency={currency} />
            <FigureCell column="Net" value={subRow.figures.net} currency={currency} />
        </>
    );
}

export function StatementLineSubRows({ line, currency }: Props) {
    return (
        <>
            {lineSubRows(line).map((subRow, index) => (
                <div key={index} className={`${STATEMENT_GRID} text-xs text-mp-muted`}>
                    <dt className="pl-8">
                        <span className="sr-only">{subRowName(line, subRow)}</span>
                    </dt>
                    <SubRowFigures subRow={subRow} currency={currency} />
                </div>
            ))}
        </>
    );
}
